import React, { useState } from "react";
import { formatAmount } from "../utils/formatAmount";
import "../styles/modal.css";

function LedgerBalanceModal({
  show,
  onClose,
  ledgerInfo,
  ipAddress,
  onVerify,
}) {
  const [otpInput, setOtpInput] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!show) return null;

  const handleSubmit = async () => {
    const result = await onVerify(otpInput);

    if (result) {
      setSuccess(true);

      setTimeout(() => {
        setSuccess(false);
        onClose();
        window.location.reload();
      }, 1500);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">

        {!success ? (
          <>
            <h3>Ledger Balance Confirmation</h3>

            <div className="modal-row">
              <strong>Customer Name:</strong>{" "}
              {ledgerInfo?.customer_name || "-"}
            </div>

            <div className="modal-row">
              <strong>Date:</strong> {ledgerInfo?.date || "-"}
            </div>

            <div className="modal-row">
              <strong>Time:</strong> {ledgerInfo?.time || "-"}
            </div>

            <div className="modal-row">
              <strong>IP Address:</strong> {ipAddress}
            </div>

            <div className="modal-row">
              <strong>SMS Phone No:</strong>{" "}
              {ledgerInfo?.phone_no || "-"}
            </div>

            <div className="modal-row">
              <strong>Balance Amount (JPY):</strong>{" "}
              {formatAmount(ledgerInfo?.balance_amount)}
            </div>

            <hr />

            {/* <div className="confirmation-message">
              {ledgerInfo?.confirm_message}
            </div> */}

            <div className="checkbox-row">
              <input
                type="checkbox"
                id="confirmCheck"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
              />

              <label htmlFor="confirmCheck">
                {ledgerInfo?.confirm_message}
              </label>
            </div>

            {/* Temporary OTP section */}
            <div className="otp-section">
              <p>
                <strong>OTP (Temporary):</strong>{" "}
                {ledgerInfo?.otp}
              </p>

              <input
                className="modal-input"
                type="text"
                value={otpInput}
                onChange={(e) => setOtpInput(e.target.value)}
                placeholder="Enter OTP"
              />
            </div>

            <div className="modal-actions">
              <button
                className="modal-btn primary"
                onClick={handleSubmit}
                disabled={!isConfirmed || !otpInput}
              >
                Confirm
              </button>

              <button
                className="modal-btn secondary"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </>
        ) : (
          <div className="success-box">
            <div className="success-icon">✔</div>
            <div className="success-text">
              Ledger Confirmed Successfully
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default LedgerBalanceModal;